import { IScale, PointData, ScaleType, SvgElement, TooltipType } from "../types";
import Bar from "./Bar";

export default class BarX extends Bar {
	addScale(type: ScaleType, scale: IScale): void {
		const realtype = type === "top" || type === "bottom" ? "left" : "top";

		super.addScale(realtype, scale);
	}

	paint(width: number, height: number, prev?: PointData[]): SvgElement {
		return super.paint(height, width, prev);
	}

	getTooltipType(id: string, x?: number, y?: number): TooltipType {
		if (this.config.baseLine !== undefined && this._baseLinePosition > x) {
			return "left";
		}
		return "right";
	}

	getClosest(x: number, y: number): [number, number, number, string] {
		const res: [number, number, number, string] = [Infinity, null, null, null];
		for (const point of this._points) {
			const dist = this._getClosestDist(x, y, point[1], point[0]);
			if (res[0] > dist) {
				res[0] = dist;
				res[1] = point[1];
				res[2] = point[0];
				res[3] = point[2];
			}
		}
		return res;
	}

	protected _getText(item) {
		return item[4].toString();
	}

	protected _getClosestDist(x, y, px, py) {
		if (this.config.stacked && x > px) {
			return Infinity;
		}
		return Math.abs(y - py);
	}

	protected _path(item, prev): string {
		item[0] += this._shift;
		return `
M ${prev} ${item[0] - this.config.barWidth / 2}
H ${item[1]}
v ${this.config.barWidth}
H ${prev}`;
	}

	protected _base(height) {
		const baseLine = this.config.baseLine;
		return (this._baseLinePosition = baseLine !== undefined ? this.yScale.point(baseLine) * height : 0);
	}

	protected _text(item, prev, rotate) {
		const x = (prev + item[1]) / 2;
		const y = item[0];
		const canRotate = rotate && !isNaN(rotate);
		return {
			x,
			y,
			class: "bar-text",
			transform: canRotate ? `rotate(${rotate} ${x} ${y})` : "",
		};
	}
}
